export function CemeteriesTemplate(params) {
    return `<table class="esri-widget__table" summary="List of attributes and values">
          <tbody>
              <tr>
                  <th class="third">Name</th>
                  <td class="two-third">{Name}</td>
              </tr>
              <tr>
                  <th class="third">Alternative Naame</th>
                  <td class="two-third">{ALT_NAME}</td>
              </tr>
              <tr>
                  <th class="third">Other</th>
                  <td class="two-third">{NOTES}</td>
              </tr>
              <tr>
                  <th class="third">Attached File</th>
                  <td class="two-third">
                      <a target="_blank" href="{Image}" class="ui fluid tiny button">View Image</a>
                  </td>
              </tr>
          </tbody>
      </table>`;
  }
  